export default __webpack_public_path__ + "media/images/images_v2/ongletlogin-365602af8762569db4d97d729d305ddb.png";